import * as React from "react"

import { cn } from "@/lib/utils"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        "h-[36px] px-[12px] rounded-[6px] border-[#EDEEF3] bg-[#FFFFFF] text-[14px] text-[#08090A] placeholder:text-[#8A8F98] hover:border-[#D1D5DB] focus-visible:ring-0 focus-visible:border-[#654EDA] transition-colors shadow-none text-left", // TODO: came from linear - this is great
        className
      )}
      {...props}
    />
  )
}

export { Input }
